export default defineNuxtRouteMiddleware((to) => {
  const { showSnackbar } = useSnackbarStore();
  const { $i18n } = useNuxtApp();
  const { t } = $i18n;

  if (['11', '4'].includes(to.params.id.toString())) {
    showSnackbar({
      type: 'error',
      message: t('common.idNotFound', { id: to.params.id.toString() })
    });

    return navigateTo({
      name: 'partner-wallets-all',
      params: { partner: to.params.partner }
    });
  }
});
